import { Component,OnInit } from '@angular/core';
import { LoaderService } from './inject-solar/dashboard/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showLoader: boolean;
  constructor(private loaderService: LoaderService) {
}

  ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
        this.showLoader = val;
    });

}
onActivate(e, outlet){
   outlet.scrollTop = 0;
  }
ngOnDestroy() {
  this.loaderService.display(false);
  this.loaderService.display(true);
}
// ngAfterViewChecked() {
// window.scrollTo(0, 0);
// }
}
